(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bekka-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => {
    document.querySelectorAll('.bekka-faq form[action], .bekka-contact form[action]').forEach(form => {
      if (form.dataset.bekkaReturnReady) return;
      form.dataset.bekkaReturnReady = 'true';
      form.addEventListener('submit', () => {
        const target = new URL(window.location.href);
        target.searchParams.set('contact_posted', 'true');
        target.hash = form.closest('.bekka-faq') ? 'bekka-faq-contact' : form.id;
        const field = form.querySelector('input[name="return_to"]');
        if (field) field.value = target.pathname + target.search + target.hash;
      });
    });
    document.querySelectorAll('.bekka-message-confirmation').forEach(dialog => {
      if (dialog.dataset.bekkaReady) return;
      dialog.dataset.bekkaReady = 'true';
      dialog.querySelector('.bekka-confirmation-close').addEventListener('click', () => dialog.close());
      dialog.showModal();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bekka-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => {
    document.querySelectorAll('.bekka-faq form[action], .bekka-contact form[action]').forEach(form => {
      if (form.dataset.bekkaReturnReady) return;
      form.dataset.bekkaReturnReady = 'true';
      form.addEventListener('submit', () => {
        const target = new URL(window.location.href);
        target.searchParams.set('contact_posted', 'true');
        target.hash = form.closest('.bekka-faq') ? 'bekka-faq-contact' : form.id;
        const field = form.querySelector('input[name="return_to"]');
        if (field) field.value = target.pathname + target.search + target.hash;
      });
    });
    document.querySelectorAll('.bekka-message-confirmation').forEach(dialog => {
      if (dialog.dataset.bekkaReady) return;
      dialog.dataset.bekkaReady = 'true';
      dialog.querySelector('.bekka-confirmation-close').addEventListener('click', () => dialog.close());
      dialog.showModal();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bekka-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  let pending;
  const refreshBagCount = async () => {
    const bag = document.querySelector('.bekka-bag');
    if (!bag) return;
    pending?.abort();
    const request = new AbortController();
    pending = request;
    try {
      const response = await fetch(bag.dataset.cartUrl + '.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: request.signal
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (request.signal.aborted || !Number.isInteger(cart.item_count)) return;
      document.querySelectorAll('[data-bekka-cart-count]').forEach((count) => {
        count.textContent = String(cart.item_count);
      });
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Unable to refresh bag count.');
    }
  };
  document.addEventListener('cart:update', refreshBagCount);
  document.addEventListener('shopify:section:load', refreshBagCount);
  window.addEventListener('pageshow', refreshBagCount);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshBagCount();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bekka-password"]) return;
  try {
    
  function initBekkaPassword() {
    document.querySelectorAll('[data-bekka-countdown]').forEach((clock) => {
      if (clock.dataset.initialized) return;
      clock.dataset.initialized = 'true';
      const target = Date.parse(clock.dataset.launch);
      const update = () => {
        const remaining = Math.max(0, Math.floor((target - Date.now()) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        ['days', 'hours', 'minutes', 'seconds'].forEach((name, i) => { clock.querySelector('[data-' + name + ']').textContent = String(values[i]).padStart(2, '0'); });
        if (remaining === 0) { clock.hidden = true; clock.parentElement.querySelector('[data-launch-ended]').hidden = false; }
        return remaining;
      };
      if (update() > 0) {
        const timer = setInterval(() => { if (!clock.isConnected || update() === 0) clearInterval(timer); }, 1000);
      }
    });
    document.querySelectorAll('.bh-password__access').forEach((details) => { if (details.querySelector('.bh-password__errors')) details.open = true; });
  }
  initBekkaPassword();
  document.addEventListener('shopify:section:load', initBekkaPassword);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bekka-product-pairings"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bekka-cart-pairings')) {
  customElements.define('bekka-cart-pairings', class extends HTMLElement {
    connectedCallback() {
      this.refresh = async () => {
        this.controller?.abort();
        this.controller = new AbortController();
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: this.controller.signal, cache: 'no-store' });
          if (!response.ok) throw new Error('Unable to refresh pairings');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const updated = html.querySelector('bekka-cart-pairings');
          if (updated && this.isConnected) this.replaceChildren(...updated.childNodes);
        } catch (error) {
          if (error.name !== 'AbortError') this.replaceChildren();
        }
      };
      document.addEventListener('cart:update', this.refresh);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:update', this.refresh);
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bekka-wig-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bekka-wig-builder')) {
  customElements.define('bekka-wig-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.cfg = JSON.parse(this.querySelector('[data-config]').textContent);
      this.t = Object.fromEntries(Object.entries(this.cfg.text).map(([key, value]) => [key, new DOMParser().parseFromString(value, 'text/html').body.textContent]));
      this.root = window.Shopify?.routes?.root || '/';
      this.state = { type: 'lace', collection: 'raw', texture: '', rows: [{ length: '', quantity: 3 }], laceKind: 'closure', laceSize: '', laceLength: '', cap: '', size: '', bleach: false, requirements: '', step: 1 };
      this.addEventListener('click', e => this.click(e));
      this.addEventListener('change', e => this.change(e));
      this.addEventListener('input', e => { if (e.target.dataset.field === 'requirements') this.state.requirements = e.target.value; });
      this.load();
    }
    async load() {
      this.querySelector('[data-loading]').hidden = false;
      try {
        const entries = await Promise.all(Object.entries(this.cfg.handles).map(async ([key, handle]) => {
          const response = await fetch(this.root + 'products/' + encodeURIComponent(handle) + '.js', { cache: 'no-store' });
          if (!response.ok) throw new Error(this.t.load_error);
          const product = await response.json();
          if (!product.variants?.length) throw new Error(this.t.load_error);
          return [key, product];
        }));
        this.products = Object.fromEntries(entries);
        const params = new URLSearchParams(location.search);
        if (['lace','half','u','v'].includes(params.get('type'))) this.state.type = params.get('type');
        if (params.get('collection') === 'multi') this.state.collection = 'multi';
        this.normalise();
        const incoming = this.hair().variants.find(v => String(v.id) === params.get('variant'));
        if (incoming?.available) {
          this.state.texture = incoming.option2;
          this.state.rows[0].length = incoming.option1;
          this.normalise();
        }
        this.querySelector('[data-loading]').hidden = true;
        this.querySelector('[data-content]').hidden = false;
        this.render();
      } catch (error) {
        this.querySelector('[data-loading-text]').textContent = this.t.load_error;
        this.querySelector('[data-retry]').hidden = false;
      }
    }
    hair() { return this.products[this.state.collection + '_hair']; }
    lace() { return this.products[this.state.collection + '_' + this.state.laceKind]; }
    service() { return this.products[this.state.type === 'lace' ? 'lace_service' : this.state.type === 'half' ? 'half_service' : 'part_service']; }
    norm(value) { return String(value || '').toLowerCase().replace(/natural\s*/g, '').replace(/[^a-z0-9]/g, ''); }
    unique(values) { return [...new Set(values.filter(Boolean))]; }
    matchingLace(kind = this.state.laceKind) {
      return this.products[this.state.collection + '_' + kind].variants.filter(v => v.available && this.norm(v.option3) === this.norm(this.state.texture));
    }
    serviceVariant() {
      const s = this.state;
      return this.service().variants.find(v => {
        if (s.type === 'lace') return v.option1 === s.cap && v.option2 === s.size && (s.bleach ? /^Pre-bleached/i.test(v.option3) : /^No pre-/i.test(v.option3));
        if (s.type === 'half') return v.option1 === s.size;
        return this.norm(v.option1) === (s.type === 'u' ? 'upartwig' : 'vpartwig') && v.option2 === s.size;
      });
    }
    normalise() {
      const s = this.state;
      const textures = this.unique(this.hair().variants.filter(v => v.available).map(v => v.option2));
      if (!textures.includes(s.texture)) s.texture = textures[0] || '';
      const lengths = this.unique(this.hair().variants.filter(v => v.available && v.option2 === s.texture).map(v => v.option1));
      s.rows.forEach(row => { if (!lengths.includes(row.length)) row.length = lengths.find(x => parseInt(x) === 18) || lengths[0] || ''; });
      if (!this.matchingLace().length) {
        const other = s.laceKind === 'closure' ? 'frontal' : 'closure';
        if (this.matchingLace(other).length) s.laceKind = other;
      }
      const laceVariants = this.matchingLace();
      const sizes = this.unique(laceVariants.map(v => v.option1));
      if (!sizes.includes(s.laceSize)) s.laceSize = sizes[0] || '';
      const laceLengths = this.unique(laceVariants.filter(v => v.option1 === s.laceSize).map(v => v.option2));
      if (!laceLengths.includes(s.laceLength)) s.laceLength = laceLengths.find(x => parseInt(x) === 16) || laceLengths[0] || '';
      if (!s.cap) s.cap = this.products.lace_service.variants[0].option1;
      if (s.type !== 'lace') s.bleach = false;
    }
    escape(value) { return String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    money(amount) { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:this.cfg.currency}).format(amount / 100); }
    options(values, selected, placeholder) {
      return (placeholder ? `<option value="">${this.escape(placeholder)}</option>` : '') + values.map(x => `<option value="${this.escape(x)}" ${x === selected ? 'selected' : ''}>${this.escape(x)}</option>`).join('');
    }
    select(field, label, values, value, placeholder) {
      return `<label class="bw-field">${this.escape(label)}<select data-field="${field}" ${placeholder ? 'required' : ''}>${this.options(values,value,placeholder)}</select></label>`;
    }
    image(product, variant, className = '') {
      const source = variant?.featured_image?.src || product.featured_image;
      if (!source) return '';
      const url = new URL(source, location.origin); url.searchParams.set('width','480');
      return `<img class="${className}" src="${this.escape(url.href)}" alt="${this.escape(product.title)}" width="240" height="280" loading="lazy">`;
    }
    chosen() {
      const s = this.state;
      const hair = s.rows.map(row => ({product:this.hair(), variant:this.hair().variants.find(v => v.option1 === row.length && v.option2 === s.texture), quantity:Number(row.quantity), role:'hair'}));
      const lace = s.type === 'lace' ? [{product:this.lace(),variant:this.matchingLace().find(v => v.option1 === s.laceSize && v.option2 === s.laceLength), quantity:1,role:'lace'}] : [];
      const service = this.serviceVariant() || this.service().variants.find(v => s.type === 'lace' ? v.option1 === s.cap && (s.bleach ? /^Pre-bleached/i.test(v.option3) : /^No pre-/i.test(v.option3)) : s.type === 'half' || this.norm(v.option1) === (s.type === 'u' ? 'upartwig':'vpartwig'));
      return [...hair,...lace,{product:this.service(),variant:service,quantity:1,role:'service'}];
    }
    render() {
      const s = this.state, t = this.t, e = value => this.escape(value);
      this.querySelectorAll('[data-type]').forEach(b => { b.setAttribute('aria-pressed',String(b.dataset.type === s.type)); });
      this.querySelectorAll('[data-step-link]').forEach(b => {
        b.setAttribute('aria-current',Number(b.dataset.stepLink) === s.step ? 'step' : 'false');
        b.hidden = s.type !== 'lace' && b.dataset.stepLink === '2';
      });
      const hairVariants = this.hair().variants.filter(v => v.available && v.option2 === s.texture);
      const lengths = this.unique(hairVariants.map(v => v.option1));
      const textures = this.unique(this.hair().variants.filter(v => v.available).map(v => v.option2));
      const chosen = this.chosen();
      const total = chosen.reduce((sum,item) => sum + (item.variant?.price || 0) * item.quantity, 0);
      let body = '';
      if (s.step === 1) {
        body = `<p class="bw-eyebrow">${e(t.step_one)}</p><h2 tabindex="-1">${e(t.hair_heading)}</h2><p>${e(t.hair_intro)}</p>
        <div class="bw-collection-options" role="group" aria-label="${e(t.collection)}">
        <button type="button" data-collection="raw" aria-pressed="${s.collection==='raw'}">${e(t.raw)}</button><button type="button" data-collection="multi" aria-pressed="${s.collection==='multi'}">${e(t.multi)}</button></div>
        <div class="bw-product-intro">${this.image(this.hair(),chosen[0].variant)}<div><h3>${e(this.hair().title)}</h3>${this.select('texture',t.texture,textures,s.texture)}<a href="${this.root}pages/textures">${e(t.texture_guide)} ↗</a></div></div>
        <div class="bw-bundle-rows">${s.rows.map((row,i) => `<div class="bw-bundle-row"><label>${e(t.length)}<select data-row="${i}" data-row-field="length">${this.options(lengths,row.length)}</select></label><label>${e(t.quantity)}<input type="number" inputmode="numeric" min="1" max="20" step="1" value="${row.quantity}" data-row="${i}" data-row-field="quantity" aria-label="${e(t.quantity)} ${i+1}"></label><span>${this.money((chosen[i].variant?.price || 0)*row.quantity)}</span>${s.rows.length>1?`<button type="button" class="bw-remove" data-remove="${i}" aria-label="${e(t.remove_length)} ${i+1}">×</button>`:''}</div>`).join('')}</div>
        <button type="button" class="bw-text-button" data-add-row>${e(t.add_length)} +</button>
        <details class="bw-guide"><summary>${e(t.bundle_guide)}</summary><p>${e(t.bundle_guidance)}</p><p>${e(t.bundle_note)}</p></details>`;
      } else if (s.step === 2) {
        const matching = this.matchingLace();
        body = `<p class="bw-eyebrow">${e(t.step_two)}</p><h2 tabindex="-1">${e(t.lace_heading)}</h2><p>${e(t.lace_intro)}</p><div class="bw-collection-options" role="group" aria-label="${e(t.lace_kind)}">${['closure','frontal'].map(kind=>`<button type="button" data-lace-kind="${kind}" aria-pressed="${kind===s.laceKind}" ${!this.matchingLace(kind).length?'disabled':''}>${e(t[kind])}</button>`).join('')}</div>
        ${matching.length?`<div class="bw-product-intro">${this.image(this.lace(),chosen.find(x=>x.role==='lace')?.variant)}<div><h3>${e(this.lace().title)}</h3><p class="bw-match">${e(t.texture)}: ${e(s.texture)}</p></div></div><div class="bw-fields">${this.select('laceSize',t.lace_size,this.unique(matching.map(v=>v.option1)),s.laceSize)}${this.select('laceLength',t.lace_length,this.unique(matching.filter(v=>v.option1===s.laceSize).map(v=>v.option2)),s.laceLength)}</div>`:`<p role="alert">${e(t.no_lace)}</p>`}`;
      } else if (s.step === 3) {
        const serviceItem=chosen.find(x=>x.role==='service');
        body=`<p class="bw-eyebrow">${e(t.step_three)}</p><h2 tabindex="-1">${e(t.service_heading)}</h2><p>${e(t.service_intro)}</p><div class="bw-service-card">${this.image(this.service(),null)}<div><h3>${e(t[s.type+'_label'])}</h3><p class="bw-service-price">${this.money(this.service().price_min)}</p><p>${e(t[s.type+'_description'])}</p></div></div><p class="bw-note">${e(t.construction_time)}</p>`;
      } else {
        const variants = this.service().variants;
        const sizes = this.unique(variants.filter(v=>v.available).map(v=>s.type==='half'?v.option1:v.option2));
        body=`<p class="bw-eyebrow">${e(t.step_four)}</p><h2 tabindex="-1">${e(t.fit_heading)}</h2><p>${e(t.fit_intro)}</p><div class="bw-fields">${s.type==='lace'?this.select('cap',t.cap,this.unique(variants.map(v=>v.option1)),s.cap):''}${this.select('size',t.cap_size,sizes,s.size,t.select_size)}</div>
        ${s.type==='lace'?`<label class="bw-field">${e(t.bleaching)}<select data-field="bleach"><option value="no" ${!s.bleach?'selected':''}>${e(t.no_bleach)}</option><option value="yes" ${s.bleach?'selected':''}>${e(t.yes_bleach)}</option></select></label>`:''}
        <label class="bw-field">${e(t.requirements)}<textarea data-field="requirements" rows="4" maxlength="2000" placeholder="${e(t.requirements_placeholder)}">${e(s.requirements)}</textarea></label><p class="bw-note">${e(t.default_requirements)}</p><p class="bw-note">${e(t.bespoke_note)} <a href="${this.root}policies/refund-policy">${e(t.returns)}</a></p>`;
      }
      this.querySelector('[data-panel]').innerHTML=body;
      this.querySelector('[data-back]').hidden=s.step===1;
      this.querySelector('[data-next]').hidden=s.step===4;
      this.querySelector('[data-next]').textContent=s.step===1&&s.type==='lace'?t.next_lace:s.step===1||s.step===2?t.next_service:t.next_fit;
      this.querySelector('[data-summary-title]').textContent=t[s.type+'_label'];
      this.querySelector('[data-summary-items]').innerHTML=chosen.map(item=>`<div class="bw-summary-item"><div><strong>${e(item.role==='service'?t.construction:item.product.title)}</strong><span>${e(item.variant?.title || t.unavailable)}${item.role==='hair'?' · '+item.quantity+' ×':''}</span>${item.role==='service'&&!s.size?`<span class="bw-muted">${e(t.size_pending)}</span>`:''}</div><span>${item.variant?this.money(item.variant.price*item.quantity):'—'}</span></div>`).join('');
      this.querySelector('[data-total]').textContent=this.money(total);
      this.querySelector('[data-mobile-total]').textContent=this.money(total);
      const count=s.rows.reduce((a,r)=>a+r.quantity,0);
      this.querySelector('[data-quantity-note]').textContent=count<2?t.low_quantity:'';
      this.querySelector('[data-add]').disabled=!!this.submitting || s.step!==4 || !s.size || chosen.some(item=>!item.variant?.available);
      this.querySelector('[data-add]').textContent=this.submitting?t.adding:t.add;
      this.querySelector('[data-summary-help]').textContent=s.step!==4?t.complete_steps:!s.size?t.select_size:t.checkout_note;
    }
    change(event) {
      if (!this.products || this.submitting) return;
      const target=event.target, field=target.dataset.field;
      if (target.dataset.row!==undefined) {
        const row=this.state.rows[Number(target.dataset.row)];
        if (target.dataset.rowField==='quantity') row.quantity=Math.max(1,Math.min(20,Math.floor(Number(target.value)||1)));
        else row.length=target.value;
      } else if (field && field!=='requirements') this.state[field]=field==='bleach'?target.value==='yes':target.value;
      this.normalise(); this.render();
    }
    click(event) {
      const button=event.target.closest('button'); if(!button||!this.contains(button))return;
      if (button.hasAttribute('data-retry')) {this.load();return;}
      if(!this.products||this.submitting)return;
      const d=button.dataset,s=this.state;
      let focus=false;
      if(d.type){s.type=d.type;s.step=1;s.size='';this.normalise();}
      else if(d.collection){s.collection=d.collection;this.normalise();}
      else if(d.laceKind){s.laceKind=d.laceKind;this.normalise();}
      else if(d.remove!==undefined){s.rows.splice(Number(d.remove),1);}
      else if(button.hasAttribute('data-add-row')){if(s.rows.length<10)s.rows.push({length:s.rows.at(-1).length,quantity:1});}
      else if(d.stepLink){const destination=Number(d.stepLink);if(destination>1&&!this.validateHair())return;if(destination>2&&!this.validateLace())return;s.step=destination;focus=true;}
      else if(button.hasAttribute('data-next')){if(!this.validateHair()||s.step===2&&!this.validateLace())return;s.step+=s.step===1&&s.type!=='lace'?2:1;focus=true;}
      else if(button.hasAttribute('data-back')){s.step-=s.step===3&&s.type!=='lace'?2:1;focus=true;}
      else if(button.hasAttribute('data-add')){this.submit();return;}
      else return;
      this.querySelector('[data-error]').textContent='';this.render();
      if(focus){this.querySelector('[data-panel] h2').focus({preventScroll:true});this.querySelector('[data-panel]').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
    }
    validateHair(){const ok=this.chosen().filter(x=>x.role==='hair').every(x=>x.variant?.available&&Number.isInteger(x.quantity)&&x.quantity>0);if(!ok)this.querySelector('[data-error]').textContent=this.t.no_hair;return ok;}
    validateLace(){const ok=this.state.type!=='lace'||this.chosen().find(x=>x.role==='lace')?.variant?.available;if(!ok)this.querySelector('[data-error]').textContent=this.t.no_lace;return ok;}
    makeItems(buildId) {
      const chosen=this.chosen();
      const description=chosen.filter(x=>x.role!=='service').map(x=>`${x.quantity} × ${x.product.title} — ${x.variant.title}`).join('; ');
      const items=new Map();
      chosen.forEach(item=>{
        const properties={'Wig build':buildId,'Wig style':this.t[this.state.type+'_label'],'_bekka_build_id':buildId};
        if(item.role==='service'){
          properties['Special Requirements']=this.state.requirements.trim()||this.t.default_requirements;
          properties['Hair selected for this wig']=description;
          properties['Construction scope']=this.t.scope;
        }
        const key=String(item.variant.id);
        if(items.has(key))items.get(key).quantity+=item.quantity;
        else items.set(key,{id:item.variant.id,quantity:item.quantity,properties});
      });
      return [...items.values()];
    }
    async submit() {
      if(this.submitting||!this.state.size||!this.serviceVariant()?.available||!this.validateHair()||!this.validateLace())return;
      this.submitting=true;this.render();this.querySelector('[data-error]').textContent='';
      this.buildId ||= 'BH-'+crypto.randomUUID().slice(0,8).toUpperCase();
      const expected=this.makeItems(this.buildId);
      try {
        const beforeResponse=await fetch(this.root+'cart.js',{cache:'no-store'});
        if(!beforeResponse.ok)throw new Error(this.t.cart_error);
        const before=await beforeResponse.json();
        if(before.items.some(x=>x.properties?._bekka_build_id===this.buildId)){location.assign(this.root+'cart');return;}
        const response=await fetch(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:expected})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||this.t.cart_error);
        location.assign(this.root+'cart');
      } catch(error) {
        try {
          const response=await fetch(this.root+'cart.js',{cache:'no-store'});
          if(!response.ok)throw new Error();
          const cart=await response.json();
          const added=cart.items.filter(x=>x.properties?._bekka_build_id===this.buildId);
          if(added.length){this.querySelector('[data-error]').textContent=this.t.check_bag;this.querySelector('[data-view-bag]').hidden=false;return;}
          this.submitting=false;
          this.querySelector('[data-error]').textContent=error.message||this.t.cart_error;
        } catch {this.querySelector('[data-error]').textContent=this.t.check_bag;this.querySelector('[data-view-bag]').hidden=false;}
        this.render();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
